import { FETCH_CARRIER, DELETE_CARRIER } from "../actions/actionTypes";

var initialState = [];

const findIndex = (data, CUST_NO) => {
  var result = -1;
  data.forEach((customer, index) => {
    if (customer.CUST_NO === CUST_NO) {
      result = index;
    }
  });
  return result;
};

const carriers = (state = initialState, action) => {
  var index = -1;
  switch (action.type) {
    case FETCH_CARRIER:
      state = action.carrier;
      return [...state];
    case DELETE_CARRIER:
      index = findIndex(state, action.CUST_NO);
      state.splice(index, 1);
      return [...state];
    default:
      return state;
  }
};

export default carriers;
